import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import Modal from "react-modal";
import downloadIcon from '../../assets/downloadIcon.png'
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import ic_filter from '../../assets/ic_filter.svg'
import { Button } from "../../common/Button/Button";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { Info } from "react-feather";

const FTUBasedOnVehicleQuestion = (props) => {

  const [MergedPartnerResourceModal, setMergedPartnerResourceModal] = useState(false)

  const gridRef = useRef()
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  //   const rowData = props.data

  // const data = props.firstTimeData
  // const data2 = props.engagedData

  const data = props.ftuVehicleQuestionCount;
  const data2 = props.ftuDeviceCount;
  const data3 = props.isFilterActive ? props.vehicleDeviceCombinationFilterData : props.vehicleDeviceCombination;

  const [rowData, setRowData] = useState([]);
  const [resourseNames, setResourseNames] = useState([]);
  const [partnerNames, setPartnerNames] = useState([])
  const [MergedData, setMergedData] = useState([]);

  useEffect(() => {
    // const maxLength = Math.max(data.length, data2.length);

    // const combined = Array.from({ length: maxLength }, (_, i) => ({
    //   vehicle: data[i]?.vehicle || "",
    //   count: data[i]?.count?.toString() || "",
    //   device: data2[i]?.device || "",
    //   deviceCount: data2[i]?.deviceCount?.toString() || ""
    // }));

    // console.log(combined, ">>>>>combined");

    // setRowData(combined)

    console.log(data3, ">>>>data3 in useEffect");
    
    setRowData(data3)
  }, [data, data2, data3])

  const footerRow = {
    resourcedisplay_name: "Total",
    // first_time_data: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.first_time_data, 0),
    count: "Total" + " : " + " " + data3.reduce((total, row) => total + row.count, 0),
  };

  // const footerRow = {
  //   device: "Total",
  //   // first_time_data: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.first_time_data, 0),
  //   // count: "Total" + " : " + " " + data.reduce((total, row) => total + row.count, 0),
  //   // deviceCount: "Total" + " : " + " " + data2.reduce((total, row) => total + row.deviceCount, 0),
  //   count: "Total" + " : " + " " + data3.reduce((total, row) => total + row.count, 0),
  // };

  const openMergedPartnerResourceModalisTrue = () => {
    setMergedPartnerResourceModal(true)
  }

  const openMergedPartnerResourceModalisFalse = () => {
    setMergedPartnerResourceModal(false)
  }

  const handleClearClick = () => {
    props.setSelectedOptionsMergedPartnerResource([])
    props.setSelectedOptionsMergedPartnerResourceEu([])
  }

  const CustomCellRenderer = (props) => {
    let resourceName = props.value;
    if (resourceName === null) {
      resourceName = "Not Provided";
    }
    if (resourceName === "Total") {
      return <div style={{ textAlign: "right", display: "none" }}>{resourceName}</div>;
    } else {
      return <div>{resourceName}</div>;
    }
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "vehicle",
      headerName: "Vehicle Name",
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", width: '50px', alignItems: "center" }}>
            <div style={{ marginRight: "110px" }}>{params.displayName}</div>
            <img
              alt=""
              src={ic_filter}
              height={"25px"}
              width={"25px"}
              className="conv-mr10"
              onClick={() => props.handleVehicleDeviceFilterOpen()}
            />
          </div>
        );
      },
      width: 380,
      cellStyle: { 'white-space': 'normal' },
      autoHeight: true,
      cellRendererFramework: CustomCellRenderer,
      //   cellRenderer: params => {
      //     let resourseName = params.value;
      //     if (resourseName === null) {
      //       resourseName = "Not Provided";
      //     }
      //     if (resourseName === "Total") {
      //       return <div style={{ textAlign: "right", display: 'none' }}>{resourseName}</div>;
      //     } else {
      //       return resourseName;
      //     }
      //   },
    },
    // {
    //   field: "count",
    //   headerName: "Vehicle Count",
    //   flex:1,
    //   headerComponentFramework: (params) => {
    //     return (
    //       <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
    //         <div>{params.displayName}</div>
    //       </div>
    //     );
    //   },
    //   width: 380,
    //   // cellStyle: { 'white-space': 'normal' },
    //   cellStyle: { textAlign: "right" },
    //   autoHeight: true,
    //   cellRendererFramework: CustomCellRenderer,
    //   // cellRenderer: params => {
    //   //   let resourseName = params.value;
    //   //   if (resourseName === null) {
    //   //     resourseName = "Not Provided";
    //   //   }
    //   //   if (resourseName === "Total") {
    //   //     return <div style={{ textAlign: "right", display: 'none' }}>{resourseName}</div>;
    //   //   } else {
    //   //     return resourseName;
    //   //   }
    //   // },
    // },
    {
      field: "device",
      headerName: "Device Name",
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", width: '50px', alignItems: "center" }}>
            <div style={{ marginRight: "110px" }}>{params.displayName}</div>
            {/* <img
                alt=""
                src={ic_filter}
                height={"25px"}
                width={"25px"}
                className="conv-mr10"
                onClick={() => openMergedPartnerResourceModalisTrue()}
            /> */}
          </div>
        );
      },
      width: 380,
      cellStyle: { 'white-space': 'normal' },
      autoHeight: true,
      cellRendererFramework: CustomCellRenderer,
    },
    // {
    //   field: "deviceCount",
    //   headerName: "Device Count",
    //   flex:1,
    //   headerComponentFramework: (params) => {
    //     return (
    //       <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center"  }}>
    //         <div>{params.displayName}</div>
    //       </div>
    //     );
    //   },
    //   width: 380,
    //   // cellStyle: { 'white-space': 'normal' },
    //   cellStyle: { textAlign: "right" },
    //   autoHeight: true,
    //   cellRendererFramework: CustomCellRenderer,
    // },
    {
      field: "count",
      headerName: "Count",
      flex: 1,
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
      width: 380,
      // cellStyle: { 'white-space': 'normal' },
      cellStyle: { textAlign: "right" },
      autoHeight: true,
      cellRendererFramework: CustomCellRenderer,
    },
  ]);


  const handleMergedPartnerResourceSelect = (selected) => {
    props.setSelectedOptionsMergedPartnerResource(selected)
    console.log("select", props.selectedOptionsMergedPartnerResource)
  }

  const handleMergedPartnerResourceSelectEu = (selected) => {
    props.setSelectedOptionsMergedPartnerResourceEu(selected)
    console.log("select", props.selectedOptionsMergedPartnerResourceEu)
  }

  // const handleMergedPartnerResourceFilterSearchClick = () => {
  //   if (props.selectedOptionsMergedPartnerResource.length > 0 && props.selectedOptionsMergedPartnerResourceEu.length > 0) {
  //     const filteredPartnerData = MergedData.filter((partner) =>
  //       props.selectedOptionsMergedPartnerResource.some((option) => option.value === partner.entrypoint_name) &&
  //       props.selectedOptionsMergedPartnerResourceEu.some((option) => option.value === partner.resourcedisplay_name)
  //     );
  //     console.log(filteredPartnerData);
  //     setRowData(filteredPartnerData);
  //   }
  //   else if (props.selectedOptionsMergedPartnerResource.length > 0) {
  //     const filteredPartnerData = MergedData.filter((partner) =>
  //       props.selectedOptionsMergedPartnerResource.some((option) => option.value === partner.entrypoint_name)
  //     );
  //     console.log(filteredPartnerData);
  //     setRowData(filteredPartnerData);
  //   } else if (props.selectedOptionsMergedPartnerResourceEu.length > 0) {
  //     const filteredPartnerData = MergedData.filter((partner) =>
  //       props.selectedOptionsMergedPartnerResourceEu.some((option) => option.value === partner.resourcedisplay_name)
  //     );
  //     console.log(filteredPartnerData);
  //     setRowData(filteredPartnerData);
  //   } else {
  //     setRowData(MergedData);
  //   }
  //   openMergedPartnerResourceModalisFalse();
  // }

  const gridOptions = useMemo(() => ({
    suppressScrollOnNewData: true,
  }), []);

  // const handleDownloadCSV = () => {
  //   const csvData = [];
  //   csvData.push('Partner Name, Resource Utilised, First Time Count, Engaged Count'); // CSV header

  //   rowData.forEach(row => {
  //     csvData.push(`${row.entrypoint_name}, ${row.resourcedisplay_name}, ${row.first_time_data}, ${row.engaged_count}`);
  //   });

  //   const csvBlob = new Blob([csvData.join('\n')], { type: 'text/csv' });
  //   const csvUrl = window.URL.createObjectURL(csvBlob);

  //   const downloadLink = document.createElement('a');
  //   downloadLink.href = csvUrl;
  //   downloadLink.download = 'partner_resource_data.csv';
  //   downloadLink.style.display = 'none';
  //   document.body.appendChild(downloadLink);
  //   downloadLink.click();

  //   window.URL.revokeObjectURL(csvUrl);
  //   document.body.removeChild(downloadLink);
  // };

  const handleDownloadCSV = () => {
    const csvData = [];
    csvData.push('Partner Name, Resource Utilized, First Time Count, Engaged Count'); // CSV header

    rowData.forEach(row => {
      // Check if 'entrypoint_name' and 'resourcedisplay_name' are null or empty
      const partnerName = (row.entrypoint_name !== null && row.entrypoint_name !== '') ? row.entrypoint_name.replace(/\n/g, ' ') : (row.entrypoint_name === null ? 'null' : '');
      const resourceUtilized = (row.resourcedisplay_name !== null && row.resourcedisplay_name !== '') ? row.resourcedisplay_name.replace(/\n/g, ' ') : (row.resourcedisplay_name === null ? 'null' : '');

      // Escape double quotes in 'partnerName' and 'resourceUtilized' to avoid CSV issues
      const escapedPartnerName = partnerName.replace(/"/g, '""');
      const escapedResourceUtilized = resourceUtilized.replace(/"/g, '""');

      // Create the CSV row
      csvData.push(`${escapedPartnerName}, ${escapedResourceUtilized}, ${row.first_time_data}, ${row.engaged_count}`);
    });

    const csvBlob = new Blob([csvData.join('\n')], { type: 'text/csv' });
    const csvUrl = window.URL.createObjectURL(csvBlob);

    const downloadLink = document.createElement('a');
    downloadLink.href = csvUrl;
    downloadLink.download = 'partner_resource_data.csv';
    downloadLink.style.display = 'none';
    document.body.appendChild(downloadLink);
    downloadLink.click();

    window.URL.revokeObjectURL(csvUrl);
    document.body.removeChild(downloadLink);
  };

  const overlayNoRowsTemplate = rowData?.length === 1 && rowData[0].sEntryPoint === "No Data Available"
    ? '<span class="ag-overlay-no-rows-center">No data available</span>'
    : '<span class="ag-overlay-no-rows-center">loading...</span>';

  console.log(rowData, ">>>>rowdata");
  return (
    <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'center',
        margin: 10
      }}>
        <h3 className="spled-colored-label" style={{
          fontSize: "20px",
          textAlign: 'center',
          marginRight: 10
        }}>6. First time Users based on Vehicle Count and Device Count</h3>
        <span style={{ cursor: "pointer" }} title="Display of First time users based on Vehicle Count and Device Count">
          <Info style={{ width: "15px", marginRight: "10px", marginBottom: "5px" }} />
        </span>
        {/* {
          rowData.length > 0 && (
            // <Button className="esp-inline-button"
            //   onClick={handleDownloadCSV}
            // >Download CSV</Button>
            <img src={downloadIcon} title="Download CSV" alt="" onClick={handleDownloadCSV} style={{
              cursor: "pointer"
            }} />
          )
        } */}
      </div>
      <div style={{
        height: "50vh",
      }}>
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <div style={gridStyle} className="ag-theme-material">
            <AgGridReact ref={gridRef}
              rowData={rowData}
              // rowData={data}
              columnDefs={columnDefs}
              pinnedBottomRowData={[footerRow]}
              gridOptions={gridOptions}
              overlayNoRowsTemplate={
                '<span class="ag-overlay-loading-center">No data available...</span>'
              }
              rowClassRules={{
                'total-row': 'data.resourcedisplay_name === "Total"'
              }}
            >
            </AgGridReact>
          </div>
        </div>

        {/* <Modal isOpen={MergedPartnerResourceModal}>
          <ModalContent className="EngagedDashboard-filter-modal">
            <div className="modal-header">
              <span className="modal-title">Filter</span>
              <img
                alt="close"
                id="Close"
                src={close_modal}
                className="close modal-close"
                onClick={openMergedPartnerResourceModalisFalse}
              />
            </div>

            <div className="modal-body">
              <br />
              <div className="row">
                <div className="col-6 spled-container">
                  <div className="width-100">
                    <ReactMultiSelectCheckboxes
                      options={partnerNames.map((partner) => ({
                        label: partner,
                        value: partner,
                      }))}
                      // placeholder="Select partners"
                      placeholderButtonLabel="Select Partner"
                      value={props.selectedOptionsMergedPartnerResource}
                      onChange={handleMergedPartnerResourceSelect}
                    />
                  </div>
                </div>
                <div className="col-6 spled-container">
                  <div className="width-100">
                    <ReactMultiSelectCheckboxes
                      options={resourseNames.map((program) => ({
                        label: program,
                        value: program,
                      }))}
                      // placeholder="Select partners"
                      placeholderButtonLabel="Select Resource"
                      value={props.selectedOptionsMergedPartnerResourceEu}
                      onChange={handleMergedPartnerResourceSelectEu}
                    />
                  </div>
                </div>
              </div>
              <br />
              <div className='row d-flex justify-content-center align-items-center'>
                <div className="offset-1 col-5">
                  <Button className="esp-inline-button" onClick={handleMergedPartnerResourceFilterSearchClick}>Search</Button>
                </div>
                <div className="col-5">
                  <Button className="esp-inline-button" onClick={handleClearClick}>Clear</Button>
                </div>
              </div>

            </div>
          </ModalContent>
        </Modal> */}
      </div>
    </div>
  )
}

export default FTUBasedOnVehicleQuestion
